/* Gamers Point product action bar. Works with existing gp-compare-tools; wishlist is local to the browser. */
(function(){
  'use strict';
  function init(){
    const root=document.querySelector('[data-gp-product-actions-root]');
    if(!root)return;
    const bar=root.querySelector('[data-gp-action-bar]');
    const id=String(root.dataset.id||'');
    if(!id||!bar)return;
    const key='gp_wishlist_v1', compareKey='gp_compare_products';
    const wishlistButton=bar.querySelector('[data-gp-wishlist-toggle]');
    const wishlistLabel=bar.querySelector('[data-gp-wishlist-label]');
    const wishlistView=root.querySelector('[data-gp-wishlist-open]');
    const wishlistCount=root.querySelector('[data-gp-wishlist-count]');
    const wishlistList=root.querySelector('[data-gp-wishlist-list]');
    const wishlistDialog=root.querySelector('[data-gp-wishlist-dialog]');
    const questionDialog=root.querySelector('[data-gp-question-dialog]');
    const compareButton=bar.querySelector('[data-gp-compare-action]');
    const compareLabel=bar.querySelector('[data-gp-compare-label]');
    const oldCompare=document.querySelector('[data-gp-feature-product] [data-gp-compare-add]');
    const status=root.querySelector('[data-gp-action-status]');
    const selectedProduct={id:id,title:root.dataset.title||'Product',url:root.dataset.url||location.href,price:root.dataset.price||'',image:root.dataset.image||''};
    function getStore(name){try{const v=JSON.parse(localStorage.getItem(name)||'[]');return Array.isArray(v)?v:[]}catch(e){return []}}
    function setStore(name,items){try{localStorage.setItem(name,JSON.stringify(items));return true}catch(e){status.textContent='Your browser could not save this selection.';return false}}
    function showStatus(message){status.textContent=message||''}
    function wishlist(){
      const saved=getStore(key).slice(0,100);
      const has=saved.some(item=>String(item.id)===id);
      wishlistButton.setAttribute('aria-pressed',String(has));
      wishlistLabel.textContent=has?'IN WISHLIST':'ADD TO WISHLIST';
      wishlistCount.textContent=String(saved.length);
      wishlistView.hidden=saved.length===0;
      wishlistList.replaceChildren();
      if(!saved.length){const p=document.createElement('p');p.textContent='No products saved yet.';wishlistList.append(p)}
      saved.forEach(item=>{
        const row=document.createElement('div');row.className='gp-wishlist-item';
        if(item.image){const img=document.createElement('img');img.src=item.image;img.alt='';img.loading='lazy';row.append(img)}
        const desc=document.createElement('div');
        const link=document.createElement('a');link.href=item.url||'#';link.textContent=item.title||'Product';desc.append(link);
        if(item.price){const small=document.createElement('small');small.textContent=item.price;desc.append(small)}
        row.append(desc);
        const remove=document.createElement('button');remove.type='button';remove.textContent='Remove';remove.setAttribute('aria-label','Remove '+String(item.title||'product')+' from wishlist');
        remove.addEventListener('click',()=>{const next=getStore(key).filter(x=>String(x.id)!==String(item.id));if(setStore(key,next)){wishlist();showStatus('Wishlist updated.')}});
        row.append(remove);wishlistList.append(row);
      });
    }
    function compare(){
      const saved=getStore(compareKey);
      const has=saved.some(item=>String(item.id)===id);
      compareButton.setAttribute('aria-pressed',String(has));
      compareLabel.textContent=has?'REMOVE FROM COMPARE':'COMPARE';
    }
    function open(dialog){
      if(!dialog)return;
      dialog.hidden=false;
      document.body.style.overflow='hidden';
      dialog.querySelector('input:not([type=hidden]),[data-gp-close]')?.focus();
    }
    function close(dialog){
      if(!dialog)return;
      dialog.hidden=true;
      if(!document.querySelector('.gp-action-overlay:not([hidden])')&&!document.querySelector('[data-gp-compare-dialog]:not([hidden])'))document.body.style.overflow='';
    }
    [wishlistDialog,questionDialog].forEach(dialog=>{
      dialog.querySelector('[data-gp-close]')?.addEventListener('click',()=>close(dialog));
      dialog.addEventListener('click',e=>{if(e.target===dialog)close(dialog)});
    });
    document.addEventListener('keydown',e=>{
      if(e.key!=='Escape')return;
      if(!wishlistDialog.hidden)close(wishlistDialog);
      if(!questionDialog.hidden)close(questionDialog);
    });
    wishlistButton.addEventListener('click',()=>{
      const saved=getStore(key).slice(0,100),ix=saved.findIndex(item=>String(item.id)===id);
      if(ix>=0)saved.splice(ix,1);else saved.push(selectedProduct);
      if(setStore(key,saved)){wishlist();showStatus(ix>=0?'Removed from wishlist.':'Saved to wishlist.')}
    });
    wishlistView.addEventListener('click',()=>{wishlist();open(wishlistDialog)});
    compareButton.addEventListener('click',()=>{
      if(!oldCompare){showStatus('Comparison is unavailable on this page.');return}
      oldCompare.click();
      compare();
    });
    bar.querySelector('[data-gp-question-open]').addEventListener('click',()=>open(questionDialog));
    const wa=root.querySelector('[data-gp-question-whatsapp]');
    wa.href='https://wa.me/97336820393?text='+encodeURIComponent('Hello Gamers Point, I have a question about '+selectedProduct.title+'. Product: '+selectedProduct.url+'. Please assist me.');
    async function copyLink(){
      try{
        if(navigator.clipboard&&navigator.clipboard.writeText){await navigator.clipboard.writeText(selectedProduct.url)}
        else{
          const input=document.createElement('textarea');input.value=selectedProduct.url;input.setAttribute('readonly','');input.style.position='fixed';input.style.left='-10000px';document.body.append(input);input.select();
          const ok=document.execCommand('copy');input.remove();if(!ok)throw new Error('Copy unavailable');
        }
        showStatus('Product link copied.');return;
      }catch(e){window.prompt('Copy this product link:',selectedProduct.url)}
    }
    bar.querySelector('[data-gp-share]').addEventListener('click',async()=>{
      if(navigator.share){
        try{await navigator.share({title:selectedProduct.title,text:'Gamers Point product',url:selectedProduct.url});showStatus('Product shared.');return}
        catch(e){if(e&&e.name==='AbortError')return}
      }
      await copyLink();
    });
    const details=document.querySelector('#MainContent [data-testid="product-information-details"] > .group-block')||
                  document.querySelector('#MainContent .product-details > .group-block')||
                  document.querySelector('#MainContent [data-testid="product-information-details"]')||
                  document.querySelector('#MainContent .product-details');
    if(details){details.append(bar);const utility=root.querySelector('[data-gp-actions-utility]');if(utility)details.append(utility);}
    if(root.querySelector('.gp-action-form-success,.gp-action-form-error'))open(questionDialog);
    wishlist();compare();
    if(oldCompare)document.body.classList.add('gp-product-actions-ready');
    window.addEventListener('storage',e=>{if(!e.key||e.key===key)wishlist();if(!e.key||e.key===compareKey)compare()});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();